import api from './axios';

/**
 * Architecture Rule 74 (extension v1.68) — per-user mute list API client.
 *
 * The mute list operates strictly on the auth user's own data (the muter
 * is always the auth user — there's no "mute someone for everyone"
 * privilege). The backend gates these endpoints with oauth.token only.
 */
export const listMutesRequest    = ()       => api.get('/chat/mutes');
export const storeMuteRequest    = (userId) => api.post(`/chat/mutes/${userId}`);
export const deleteMuteRequest   = (userId) => api.delete(`/chat/mutes/${userId}`);
